module.exports = __webpack_public_path__ + "static/img/model2-8.5850da13.jpg";